import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import {
  LayoutHalfPageDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_HALF_PAGE,
  LAYOUT_LIST,
  QUIZ_CHOICE,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import {
  detectMultiSelect,
  quizLegendText
} from '~/training/sequence/templates/translators/itemHelpers/Quiz';
import {
  KICKER_HINT,
  OPTIONAL_TEXT_FIELDS,
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';

export const Quiz2: Translator = sequence => {
  const optional = optionalFieldsInEditor(OPTIONAL_TEXT_FIELDS);
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Question':
        return {
          id: item.id,
          type: LAYOUT_HALF_PAGE,
          values: {
            side: 'right'
          },
          items: [
            {
              type: LAYOUT_COLUMNS,
              id: '1',
              values: {},
              items: [
                {
                  id: item.id,
                  type: LAYOUT_LIST,
                  values: { align: 'left' },
                  items: [
                    {
                      type: TEXT,
                      id: `${item.id}_subtitle`,
                      items: [],
                      values: {
                        ...optionalFieldValues(
                          optional,
                          'subtitle',
                          KICKER_HINT
                        ),
                        value: item.subtitle,
                        variant: 'sub_heading',
                        icon: item?.icon || ''
                      }
                    },
                    {
                      type: TEXT,
                      id: `${item.id}_title`,
                      items: [],
                      values: {
                        ...optionalFieldValues(optional, 'title'),
                        value: item.title,
                        variant: 'heading1'
                      }
                    },
                    {
                      type: TEXT,
                      id: `${item.id}_body`,
                      items: [],
                      values: {
                        ...optionalFieldValues(optional, 'body'),
                        value: item.body
                      }
                    },
                    {
                      type: QUIZ_CHOICE,
                      id: '1',
                      values: {
                        variant:
                          item.items && item.items.length > 2 ? 'list' : '',
                        title: quizLegendText(item.title, item.body),
                        length: item?.items?.length,
                        multiSelect: item?.items?.filter(
                          item => item.correct === true
                        ).length
                      },
                      items: AnswerButtonHelper({
                        group: null,
                        items: item.items,
                        llamaSurvey: item.llamaSurvey,
                        question: item.title || '',
                        correctAnswers: item.items
                          ? detectMultiSelect(item.items)
                          : []
                      })
                    }
                  ]
                } as LayoutListDefinition
              ]
            }
          ]
        } as LayoutHalfPageDefinition;
      default:
        return null;
    }
  });
};
